import Vue from 'vue';
import BootstrapVue from 'bootstrap-vue';
import App from './App';
import router from './router';
import store from './store';
import Toaster from 'v-toaster';
import VueLodash from 'vue-lodash';
import lodash from 'lodash';
import VeeValidate from 'vee-validate';
import vSelect from 'vue-select';
import { formatDatetime, format12Hours, formatDate } from './filters/datetime';
import VueI18n from 'vue-i18n';
import viMessage from './lang/vi.json';
import enMessage from './lang/en.json';
import * as L from 'leaflet';
import GestureHandling from 'leaflet-gesture-handling';
import 'leaflet-search/src/leaflet-search';
import 'leaflet-search/src/leaflet-search.css';
import './utils/leaflet-location.min.js';
import './utils/leaflet-location.min.css';
import 'leaflet-routing-machine/dist/leaflet-routing-machine.css';
import 'leaflet-routing-machine';
import 'leaflet-control-geocoder';
import './utils/leaflet-measure.css';
import './utils/leaflet-measure.en.js';
import 'leaflet-draw/dist/leaflet.draw.js';
import 'leaflet-draw/dist/leaflet.draw.css';
import 'leaflet.browser.print/dist/leaflet.browser.print.min.js';
import 'leaflet.markercluster/dist/MarkerCluster.css';
import 'leaflet.markercluster/dist/leaflet.markercluster.js';
import './utils/leaflet-photo.js';
import './utils/leaflet-photo.css';
import './utils/leaflet-bing.js';

import {
    LMap,
    LTileLayer,
    LMarker,
    LControlZoom,
    LIcon,
    LTooltip,
    LGeoJson,
    LControl,
    LControlLayers
} from 'vue2-leaflet';
import VueApexCharts from 'vue-apexcharts';
import 'leaflet/dist/leaflet.css';
import 'leaflet-gesture-handling/dist/leaflet-gesture-handling.css';
import { VueEditor } from 'vue2-editor';

// For Leaflet Icon
import { Icon } from 'leaflet';

delete Icon.Default.prototype._getIconUrl;
Icon.Default.mergeOptions({
    iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
    iconUrl: require('leaflet/dist/images/marker-icon.png'),
    shadowUrl: require('leaflet/dist/images/marker-shadow.png')
});

Vue.use(VueApexCharts);
Vue.use(VueEditor);
Vue.use(L);
Vue.use(BootstrapVue);
Vue.use(Toaster, { timeout: 3000 });
Vue.use(VeeValidate, { fieldsBagName: 'veeFields' });
Vue.use(require('vue-moment'));
Vue.use(VueLodash, { name: 'custom', lodash: lodash });
Vue.use(VueI18n);

// Leaflet Map initHook to use gestureHandling
L.Map.addInitHook('addHandler', 'gestureHandling', GestureHandling);

const messages = {
    vi: viMessage,
    en: enMessage
};
export const i18n = new VueI18n({
    locale: 'vi',
    messages,
    fallbackLocale: 'vi'
});

Vue.component('v-select', vSelect);
Vue.component('l-map', LMap);
Vue.component('l-tile-layer', LTileLayer);
Vue.component('l-marker', LMarker);
Vue.component('l-control-zoom', LControlZoom);
Vue.component('l-icon', LIcon);
Vue.component('l-control', LControl);
Vue.component('l-tooltip', LTooltip);
Vue.component('l-geo-json', LGeoJson);
Vue.component('l-control-layers', LControlLayers);
Vue.component('apex-chart', VueApexCharts);
Vue.component('vue2-editor', VueEditor);

Vue.filter('formatDateTime', formatDatetime);
Vue.filter('formatDate', formatDate);
Vue.filter('format12Hours', format12Hours);

Vue.directive('click-outside', {
    bind: function(el, binding, vNode) {
        // Provided expression must evaluate to a function.
        if (typeof binding.value !== 'function') {
            const compName = vNode.context.name;
            let warn = `[Vue-click-outside:] provided expression '${binding.expression}' is not a function, but has to be`;
            if (compName) {
                warn += `Found in component '${compName}'`;
            }

            console.warn(warn);
        }
        // Define Handler and cache it on the element
        const handler = e => {
            if (!el.contains(e.target) && el !== e.target) {
                binding.value(e);
            }
        };
        el.__vueClickOutside__ = handler;

        // add Event Listeners
        document.addEventListener('click', handler);
    },

    unbind: function(el, binding) {
        // Remove Event Listeners
        document.removeEventListener('click', el.__vueClickOutside__);
        el.__vueClickOutside__ = null;
    }
});

new Vue({
    el: '#app',
    i18n,
    router,
    store,
    template: '<App/>',
    components: {
        App
    }
});
